import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import ComingSoon from "./ComingSoon";
// import Settings from "./Settings";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("admin") === "true";
    setIsLoggedIn(stored);
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          isLoggedIn ? (
            <Navigate to="/dashboard" />
          ) : (
            <Login onLogin={() => setIsLoggedIn(true)} />
          )
        }
      />
      <Route
        path="/dashboard"
        element={
          isLoggedIn ? (
            <Dashboard onLogout={() => setIsLoggedIn(false)} />
          ) : (
            <Navigate to="/" />
          )
        }
      />
      <Route
        path="/export"
        element={isLoggedIn ? <ComingSoon title="Export Center" /> : <Navigate to="/" />}
      />
      <Route
        path="/help"
        element={isLoggedIn ? <ComingSoon title="Help & Support" /> : <Navigate to="/" />}
      />
    {/* <Route path="/settings" element={isLoggedIn ? <Settings /> : <Navigate to="/" />} /> */}
    </Routes>
  );
}

export default App;
